import { NgModule } from '@angular/core';
import { DxFileUploaderModule, DxButtonModule, DxSchedulerModule, DxLinearGaugeModule, DxContextMenuModule, DxCalendarModule, DxDataGridModule, DxTreeListModule, DxTreeViewModule, DxTabsModule, DxDropDownBoxModule, DxTextAreaModule, DxTextBoxModule, DxLookupModule, DxSelectBoxModule } from 'devextreme-angular';
import config from 'devextreme/core/config';
import { locale, loadMessages } from "devextreme/localization" 
import Form, { Properties } from "devextreme/ui/form";
import * as deMessages from 'devextreme/localization/messages/de.json';

@NgModule({
  imports: [
    // DevExtremeModule,
    DxCalendarModule,
    DxButtonModule,
    DxSchedulerModule,
    DxLinearGaugeModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxTreeListModule,
    DxTreeViewModule,
    DxTabsModule,
    DxDropDownBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxFileUploaderModule,
  DxLookupModule,
  DxSelectBoxModule	
  ],
  exports: [
    // DevExtremeModule,
    DxCalendarModule,
    DxButtonModule,
    DxSchedulerModule,
    DxLinearGaugeModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxTreeListModule,
    DxTreeViewModule,
    DxTabsModule,
    DxDropDownBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxFileUploaderModule,
    DxLookupModule,
    DxSelectBoxModule
  ],
})

export class DevExtremeModule {

  locale: string = 'de';

  constructor() {

    config({
      editorStylingMode: 'outlined', // 'filled' or 'outlined' | 'underlined'
      forceIsoDateParsing: true,
      defaultCurrency: 'EUR'
    });

    Form.defaultOptions<Properties>({
      options: {
        labelMode: "static"
      }
    });  

    loadMessages(deMessages);
    locale(this.locale);                
  }
}




